<template>
    <div>
        <section class="box-item">
            <h3 class="approve_title">{{$t('SUBTITLE.EUR.COMP.USER.INFO')}}</h3>
            <table class="approve_table">
                <colgroup>
                    <col width="270px">
                    <col width="*">
                    <col width="270px">
                    <col width="*">
                </colgroup>
                <tbody>
                    <tr>
                        <th>{{$t('FIELD.GLOBAL.ID')}}({{$t('FIELD.GLOBAL.EMAIL')}})</th>
                        <td>{{userInfo.userEmail}}</td>
                        <th>{{$t('FIELD.PROFILE.COMPANY.NAME')}}</th>
                        <td>{{userInfo.companyName}}</td>
                    </tr>
                    <tr>
                        <th>{{$t('FIELD.COMPANY.REGISTRATION.NUMBER')}}</th>
                        <td>{{userInfo.companyRegNo}}</td>
                        <th>{{$t('FIELD.CONTACT.PHONE.NUMBER')}}</th>
                        <td>{{userInfo.phoneNumber}}</td>
                    </tr>
                    <tr>
                        <th>{{$t('FIELD.EUR.FIRST.NAME')}}</th>
                        <td>{{userInfo.contactFirstName}}</td>
                        <th>{{$t('FIELD.EUR.LAST.NAME')}}</th>
                        <td>{{userInfo.contactLastName}}</td>
                    </tr>
                    <tr>
                        <th>{{$t('FIELD.POSTAL.CODE')}}</th>
                        <td>{{userInfo.zipCode}}</td>
                        <th>{{$t('FIELD.EUR.COMP.ADDR')}}</th>
                        <td>{{userInfo.companyAddress}}</td>
                    </tr>
                    <tr>
                        <th>{{$t('FIELD.COMPANY.WEBSITE.ADDRESS')}}</th>
                        <td>{{userInfo.companyWebAddress}}</td>
                        <th>{{$t('FIELD.INSURANCE.POLICY')}}</th>
                        <td v-if="userInfo.fileLength1 > 0">
                            <a href="JavaScript:" class="link_attch" @click="downloadFile('1')"><span class="ico_attach"></span>{{userInfo.fileName1}}</a> ({{userInfo.fileLength1 | numberFormat }}KB)
                        </td>
                    </tr>
                    <tr>
                        <th>{{$t('FIELD.EUR.APE.CODES')}}</th>
                        <td>{{userInfo.apeCodes}}</td>
                        <th>{{$t('FIELD.COMPANY.REGISTRATION.FILE')}}</th>
                        <td v-if="userInfo.fileLength2 > 0">
                            <a href="JavaScript:" class="link_attch" @click="downloadFile('2')"><span class="ico_attach"></span>{{userInfo.fileName2}}</a> ({{userInfo.fileLength2 | numberFormat }}KB)
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>

        <section class="list-item">
            <div class="item-left">
                <h3 class="approve_title">{{$t('SUBTITLE.AUTHREQ.REQUEST')}}</h3>
                <table class="approve_table">
                    <colgroup>
                        <col width="290px">
                        <col width="*">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{{$t('FIELD.GLOBAL.REQUEST.DATE')}}</th>
                            <td>{{reqtInfo.REQ_DT}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.EUR.REQ.TYPE')}}</th>
                            <td>{{reqtInfo.REQ_TYPE_NM}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.REQUEST.MODEL.CODE')}}</th>
                            <td>{{reqtInfo.MODEL_CD}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.MAJOR.PRODUCT.CATEGORY')}}</th>
                            <td>{{reqtInfo.CATE_MAIN_NM}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.SUB.PRODUCT.CATEGORY')}}</th>
                            <td>{{reqtInfo.CATE_SUB_NM}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.REQUESTED.CONTENTS')}}</th>
                            <td>{{reqtInfo.SEL_CNTNTS}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.RECENT.REQUESTED.PRODUCT')}}</th>
                            <td>{{isPrevCategory}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.RELATED.CONTENTS.EXISTS')}}</th>
                            <td>{{reqtInfo.CNTNTS_EXIST}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.PREVIOUS.APPROVAL')}}</th>
                            <td>{{reqtInfo.PRE_APPROVAL}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="item-right">
                <h3 class="approve_title">{{$t('FIELD.EUR.APPR.REJT.INFO')}}</h3>
                <table class="approve_table">
                    <colgroup>
                        <col width="200px">
                        <col width="*">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{{$t('FIELD.EUR.CONTS.SEND.YN')}}</th>
                            <td>{{reqtInfo.CONT_SEND_YN}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.APPROVAL.STATUS')}}</th>
                            <td>{{reqtInfo.STATUS_NM}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.EUR.FIRST.APPROVER')}}</th>
                            <td>{{reqtInfo.APR_FRST_APPROVER}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.1ST.APPROVAL.DATE')}}</th>
                            <td>{{reqtInfo.APR_FRST_DT}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.EUR.SECOND.APPROVER')}}</th>
                            <td>{{reqtInfo.APR_SCND_APPROVER}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.2ND.APPROVAL.DATE')}}</th>
                            <td>{{reqtInfo.APR_SCND_DT}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.ADMIN.REJECT.REASON')}}</th>
                            <td>
                                <span v-if="reqtInfo.REJECT_REASON_CD">{{reqtInfo.REJECT_REASON_CD}}: {{reqtInfo.REJECT_REASON_NM}}</span>
                                <span v-else>N/A</span>
                            </td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.EUR.DETAIL.REJECT.REASON')}}</th>
                            <td>
                                <textarea readonly class="view_textarea" v-model="reqtInfo.REJ_REASON"></textarea>                                                
                            </td>
                        </tr>
                        <tr>
                            <th>{{$t('FIELD.EUR.REJECT.DATE')}}</th>
                            <td>{{reqtInfo.REJECT_DT}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <div class="btn_wrap_full topLine">
            <a href="JavaScript:" class="btn_white" @click="goListBack">List</a>
        </div>
    </div>
</template>

<script>
import $                from 'jquery';
import qs               from 'query-string';
import Vue              from 'vue';
import api              from '@/service';
import axios            from 'axios';
import store            from '@/vuex/store';
import { EventBus }     from '@/utils/EventBus';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import SearchUserPopup  from '~va/qnaManager/popup/searchUserPop';

export default {
    name: 'EurAdminReqDetail',
    props: {
        pDetParams: { type: Object, default: {} }
    },
    components: {
//        'skp-breadcrumbs': SKPBreadcrumbs
    },
    computed: {
        ...mapGetters({
            loginRhq: 'getLoginRhq',
            corpCd  : 'getCorpCd',
            loginNo : 'getLoginNo'
        })
    },
    data() {
        return {
            userInfo: {},
            reqtInfo: {},
            isPrevCategory: ''
        };
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            return await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
        },
        loadReqApprInfo() {
            SDLUtil.showLoadingBar(true);
            console.log('view.pDetParams ========> ', this.pDetParams);
            const url = `${SDLUtil.API_URL}/basis/eur/getReqApprHistoryInfo.skp`;
            const param = {
                  reqSeq   : this.pDetParams.REQ_SEQ
                , bpNo     : this.pDetParams.BP_NO
                , guid     : this.pDetParams.GUID
                , countryCd: this.pDetParams.COUNTRY_CD
            };
            return axios
                .post(url, qs.stringify(param))
                .then(resp => {
                    this.userInfo = resp.data.userInfo;
                    this.reqtInfo = resp.data.reqInfo;
                    console.log('Detail.resp.reqInfo ====> ', resp.data.reqInfo);
                    console.log('Detail.resp.userInfo ===> ', resp.data.userInfo);
                    if (this.reqtInfo.COMP_CATE == this.reqtInfo.PREV_CATE) {
                        this.isPrevCategory = 'SAME';
                    } else if (!this.reqtInfo.PREV_CATE) {
                        this.isPrevCategory = 'NONE';
                    } else {
                        this.isPrevCategory = 'DIFFERENCE';
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    console.error(err);//console.error(error);//cb 22.8.24 error undefined
                    SDLUtil.showLoadingBar(false);
                });
        },
        downloadFile(fileType) {
            const url = `${SDLUtil.API_URL}/noauth/eur/getAttachFileInfo.skp`;
            let params = {
                  fileType : fileType
                , guid     : this.pDetParams.GUID
                , bpNo     : this.pDetParams.BP_NO
                , corpNo   : this.pDetParams.CORP_NO
            };
            axios.post(url, qs.stringify(params))
            .then(resp => {
                console.log('fileDownload.resp.data.fileDownUrl ===> ', resp.data.fileDownUrl);
                let filePath = resp.data.fileDownUrl.replace(/\\/g, '/');
                console.log('filePath ===> ', filePath);
                let fName = filePath.split('/').pop();
                let links = document.createElement('a');
                links.href     = filePath;
                links.download = fName; // resp.data.fileDownUrl;
                links.target   = '_blank';
                document.body.appendChild(links);
                links.click();
                document.body.removeChild(links);
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
            });
        },
        attachFileClear() {
            let fNames = '';
            // this.userInfo.fileName1
            if (this.userInfo.fileName1) fNames = this.userInfo.fileName1;
            if (this.userInfo.fileName2) {
                if (fNames.length > 0) fNames += ',' + this.userInfo.fileName2;
                else                   fNames = this.userInfo.fileName2;
            }
            let params = { fileNames: fNames };
            axios.post(`${SDLUtil.API_URL}/noauth/eur/clearAttachFiles.skp`, 
                 qs.stringify(params))
                .then(resp => {
                    console.log('clearFiles.resp ===> ', resp);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
            });
        },
        goListBack() {
            this.attachFileClear();
            EventBus.$emit('goApproverList', 1);
        },
    },
    mounted() {
/*         this.getCodeComboList(this.loginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
            this.rhqCdList = data;
            this.getCodeComboList(this.rhqCdList[0].code, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
                console.log('data ==> ', data);
            });
        });
        
 */
        this.loadReqApprInfo();
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/ReqApprHistoryDetail.vue